// extracted by mini-css-extract-plugin
export default {"move":"MoveController_move__pWEMU"};